var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"at-userbar_loader at-inner-loaader"},[_c('span',[_c('i',{staticClass:"at-spinericon"})])])}]

export { render, staticRenderFns }